import { DataBean } from "../DataBean";

export class AssetItemHistory extends DataBean {


    public async getFixedAssetItemHistory(idItem: number, showNullifyDocuments: boolean, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetItemHistory_Number_Boolean_Number_Number", [idItem, showNullifyDocuments, page, recordsPerPage]);
    }
}